import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface ResearchDocument {
  id: string;
  title: string;
  slug: string;
  category: string;
  summary: string | null;
  content: string;
  file_size_bytes: number | null;
  author: string;
  published_at: string;
}

export function useResearchDocuments(category?: string) {
  return useQuery({
    queryKey: ["research-documents", category],
    queryFn: async () => {
      let query = (supabase as any)
        .from("research_documents")
        .select("id, title, slug, category, summary, author, published_at, file_size_bytes")
        .order("title");
      if (category) query = query.eq("category", category);
      const { data, error } = await query;
      if (error) throw error;
      return (data || []) as ResearchDocument[];
    },
  });
}

export function useResearchDocument(slug: string | null) {
  return useQuery({
    queryKey: ["research-document", slug],
    enabled: !!slug,
    queryFn: async () => {
      const { data, error } = await (supabase as any)
        .from("research_documents")
        .select("*")
        .eq("slug", slug)
        .single();
      if (error) throw error;
      return data as ResearchDocument;
    },
  });
}
